import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'nx-ng-basket-add-item',
  templateUrl: './basket-add-item.component.html',
  styleUrls: ['./basket-add-item.component.scss'],
})
export class BasketAddItemComponent {
  @Input()
  label = '';

  @Output()
  addBasketItem: EventEmitter<Event> = new EventEmitter<Event>();

  handleClick(event: Event) {
    this.addBasketItem.emit(event);
  }
}
